<template>
    <div id="dashboard">
        <div class="row">
            <div class="col-lg-3 col-md-4 col-sm-12 col-12">
            </div>
            <div class="col-lg-9 col-md-8 col-sm-12 col-12">
                <!-- <a href="" class="back" v-text="translate.trans('dashboard.go_back_settings')"></a> -->
                <h1 v-text="translate.trans('pinker.titleHomePage')"></h1>
            </div>
        </div>
    </div>
</template>

<script>
import DibbleTranslation from "../../translation/translation";
import DibbleJS from "../../dibble";
export default {
    name: "Dashboard",
    display: "Transition",
    data() {
        return {
            translate: DibbleTranslation,
            dibbleJs: DibbleJS,
        }
    },
    mounted() {

    },
    methods: {

    }
}
</script>

<style scoped>
    .product-image {
        width: 50px;
        height: 55px;
    }

    .line-link:before {
        right: 30px;
    }
</style>
